import { useMediaQuery } from '@mui/material';
import Icon from '@pwc/pwc-deals-ui/build/common/Icon';
import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import featureFlags from '../../helpers/featureFlags';
import { getNavigationTitle } from '../../helpers/getCustomNavigationTitles';
import { useFeaturePerTerritoryConfig } from '../../helpers/projectInitUtil';
import {
  addAnalysisTypePath,
  addContentSetTypePath,
  createHypothesisPath,
  createProjectTopicPath,
} from '../../services/urlService';
import Separator from '../Separator';

const iconSize = 24;
export const ProjectItemsNavMenuPopover = ({
  projectId,
  isOpen,
  top,
  closePopover,
  isPwcUser,
}) => {
  const projectImportConfig = useFeaturePerTerritoryConfig('projectImport');
  const isProjectImportTerritoryAllowed = Boolean(projectImportConfig?.value);
  const isMobile = useMediaQuery('(max-width:767px)');

  const addHypothesisHref = createHypothesisPath(projectId);
  const addAnalysisTypeHref = addAnalysisTypePath(projectId);
  const addContentSetTypeHref = addContentSetTypePath(projectId);
  const addProjectTopicHref = createProjectTopicPath(projectId);
  const { t } = useTranslation();
  const renderAddAnalysisOption = () => {
    const comp = addAnalysisTypeHref;
    const text = t('addAnAnalysis');

    return (
      <Link
        data-testid="add-analysis-button"
        className="dropdown-item"
        to={comp}
        onClick={closePopover}
        disabled={isMobile}
      >
        <Icon
          name="analysis"
          width={iconSize}
          className="outline icon-orange-theme"
        />
        {text}
      </Link>
    );
  };
  const renderAddContentSet = () => {
    const comp = addContentSetTypeHref;
    const text = 'addAContentSet';

    return (
      <>
        <Separator />
        <Link
          data-testid="add-content-set-button"
          className="dropdown-item"
          to={comp}
          onClick={closePopover}
        >
          <Icon
            name="grid"
            width={iconSize}
            className="outline icon-orange-theme"
          />
          {t(text)}
        </Link>
      </>
    );
  };
  const KFATitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);

  return (
    <>
      <div
        className={`add-popover ${isOpen ? 'show' : ''}`}
        style={isOpen ? { top: `${top}px` } : undefined}
        data-testid="add-popover"
      >
        {featureFlags.isPOTopicRefactorEnabled && (
          <Link
            data-testid="add-po-topic-button"
            className="dropdown-item"
            to={addProjectTopicHref}
            onClick={closePopover}
          >
            <Icon
              name="folder-closed"
              width={iconSize}
              className="outline icon-orange-theme"
            />
            <span className="add-item-title">{t('addATopic')}</span>
          </Link>
        )}
        <Link
          data-testid="add-hypothesis-button"
          className="dropdown-item"
          to={addHypothesisHref}
          onClick={closePopover}
        >
          <Icon
            name="hypothesis"
            width={iconSize}
            className="outline icon-orange-theme"
          />
          <span className="add-item-title">
            {t('addKeyFocusArea', { KFATitle })}
          </span>
        </Link>
        {renderAddAnalysisOption()}
        {featureFlags.isContentTemplateSetEnabled
          ? featureFlags.isProjectImportEnabled &&
            isPwcUser &&
            renderAddContentSet()
          : featureFlags.isProjectImportEnabled &&
            isProjectImportTerritoryAllowed &&
            isPwcUser &&
            renderAddContentSet()}
      </div>

      {isOpen && (
        <div
          className="add-popover-overlay"
          onClick={closePopover}
          data-testid="add-popover-overlay"
          role="presentation"
        />
      )}
    </>
  );
};
